"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = overrideScriptsLocationMapFromQuery;

var _replaceUrlVersion = _interopRequireDefault(require("./replaceUrlVersion"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function overrideScriptsLocationMapFromQuery(scriptsLocationMap, overrideParam) {
  overrideParam.split(',').filter(Boolean).forEach(function (keyValueString) {
    var pair = keyValueString.split(':');
    var urlOverride = (0, _replaceUrlVersion["default"])(scriptsLocationMap[pair[0]], pair[1]);

    if (urlOverride && scriptsLocationMap[pair[0]] !== urlOverride) {
      scriptsLocationMap[pair[0]] = urlOverride;
    }
  });
  return scriptsLocationMap;
}
//# sourceMappingURL=overrideScriptsLocationMapFromQuery.js.map